import { render, staticRenderFns } from "./ThePrivacyPolicy.vue?vue&type=template&id=cda993cc&"
import script from "./ThePrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./ThePrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ThePrivacyPolicy.vue?vue&type=style&index=0&id=cda993cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports